import clsx from 'clsx';

const OptionButtonGrid = ({
  options,
  value,
  onChange,
  className,
  outOfStock,
  isMicrositeFeature
}) => {
  return (
    <div
      className={clsx(
        isMicrositeFeature
          ? 'grid grid-cols-3 gap-3'
          : 'grid grid-cols-[repeat(auto-fit,minmax(100px,1fr))] gap-3',
        className
      )}
    >
      {options.map((option) => {
        const isSelected = option.value === value;
        const variantOutOfStock = option.label?.includes('(Out of Stock)');
        const isOutOfStock = variantOutOfStock || outOfStock;

        return (
          <button
            key={option.value}
            type="button"
            data-out-of-stock={isOutOfStock}
            onClick={() => onChange({ target: { value: option.value } })}
            className={clsx(
              isMicrositeFeature
                ? 'relative flex flex-1 flex-col gap-2 overflow-hidden border-2 px-3 py-4 text-center text-sm text-white transition-colors'
                : 'relative overflow-hidden border-2 px-4 py-3 text-center text-sm text-white transition-colors',

              isSelected
                ? clsx(
                    'border-light-green text-green-200',
                    isOutOfStock ? 'bg-parlor-green-80' : 'bg-parlor-green-95'
                  )
                : isOutOfStock
                  ? 'border-parlor-green-60 bg-parlor-green-80'
                  : 'border-parlor-green-80 bg-parlor-green hover:bg-parlor-green-95 hover:text-white'
            )}
          >
            <span className="relative z-10 block text-center break-words whitespace-normal lg:whitespace-nowrap">
              {option.value}
            </span>

            {/* Diagonal line for disabled button */}
            {isOutOfStock && (
              <svg
                className="absolute inset-0 z-0 h-full w-full"
                viewBox="0 0 100 100"
                preserveAspectRatio="none"
              >
                <line
                  x1="0"
                  y1="0"
                  x2="100"
                  y2="100"
                  stroke="#6E8788"
                  strokeWidth="2"
                  vectorEffect="non-scaling-stroke"
                />
              </svg>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default OptionButtonGrid;
